import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Button,
  // Card,
  // CardContent,
  // Table,
  // TableBody,
  // TableCell,
  // TableContainer,
  // TableHead,
  // TableRow,
  // Paper,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Chip,
  // FormControl,
  // InputLabel,
  // Select,
  // MenuItem,
  // Pagination,
  Grid,
  Alert,
  Autocomplete,
  Switch,
  FormControlLabel,
  CircularProgress,
  Tooltip,
} from '@mui/material';

import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  // Search as SearchIcon,
  // Clear as ClearIcon,
  Block as BlockIcon,
  CheckCircle as CheckCircleIcon,
} from '@mui/icons-material';

import API_CONFIG from '../config/api.config';
import MUIDataTable from "mui-datatables";
import { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';
import { useAuth } from '../contexts/AuthContext';

const AdminTreatmentsPage = () => {
  const { canEdit } = useAuth();
  // Состояния для данных
  const [treatments, setTreatments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalCount, setTotalCount] = useState(0);

  // Состояния для пагинации и фильтрации
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [search, setSearch] = useState('');
  const [diseaseFilter, setDiseaseFilter] = useState('');
  const [productFilter, setProductFilter] = useState('');
  const [activeFilter, setActiveFilter] = useState('');

  // Состояния для модального окна
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editingTreatment, setEditingTreatment] = useState(null);
  const [formData, setFormData] = useState({
    disease_name: '',
    product_name: '',
    product_image: '',
    disease_description: '',
    dosage: '',
    purchase_link: '',
    is_active: true
  });

  // Данные для dropdown'ов
  const [diseases, setDiseases] = useState([]);
  const [products, setProducts] = useState([]);
  const [dosages, setDosages] = useState([]);

  // Состояния для уведомлений
  const [alert, setAlert] = useState({ show: false, message: '', severity: 'success' });

  // Загрузка данных
  const fetchTreatments = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');

      const params = new URLSearchParams({
        // page: page.toString(),
        // limit: limit.toString(),
        page: 1,
        limit: 0,
        ...(search && { search }),
        ...(diseaseFilter && { disease_filter: diseaseFilter }),
        ...(productFilter && { product_filter: productFilter }),
        ...(activeFilter !== '' && { active_filter: activeFilter })
      });

      const response = await fetch(`${API_CONFIG.BASE_URL}/admin/treatments?${params}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      const data = await response.json();

      if (data.success) {
        setTreatments(data.data);
        setTotalCount(data.pagination.total);
      } else {
        setAlert({ show: true, message: data.message || 'Ошибка загрузки данных', severity: 'error' });
      }
    } catch (error) {
      setAlert({ show: true, message: 'Ошибка подключения к серверу', severity: 'error' });
    } finally {
      setLoading(false);
    }
  };

  // Загрузка dropdown данных
  const fetchDropdownData = async () => {
    try {
      const token = localStorage.getItem('token');
      const headers = {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      };

      const [diseasesRes, productsRes, dosagesRes] = await Promise.all([
        fetch(`${API_CONFIG.BASE_URL}/admin/treatments/diseases`, { headers }),
        fetch(`${API_CONFIG.BASE_URL}/admin/treatments/products`, { headers }),
        fetch(`${API_CONFIG.BASE_URL}/admin/treatments/dosages`, { headers })
      ]);

      const [diseasesData, productsData, dosagesData] = await Promise.all([
        diseasesRes.json(),
        productsRes.json(),
        dosagesRes.json()
      ]);

      if (diseasesData.success) setDiseases(diseasesData.data);
      if (productsData.success) setProducts(productsData.data);
      if (dosagesData.success) setDosages(dosagesData.data);
    } catch (error) {
      console.error('Ошибка загрузки dropdown данных:', error);
    }
  };

  useEffect(() => {
    fetchTreatments();
    fetchDropdownData();
  }, []);

  // Обработчики для модального окна
  const handleOpenDialog = (treatment = null) => {
    if (treatment) {
      setEditingTreatment(treatment);
      setFormData(treatment);
    } else {
      setEditingTreatment(null);
      setFormData({
        disease_name: '',
        product_name: '',
        product_image: '',
        disease_description: '',
        dosage: '',
        purchase_link: '',
        is_active: true
      });
    }
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setEditingTreatment(null);
  };

  const handleFormChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  // Сохранение препарата
  const handleSave = async () => {
    try {
      const token = localStorage.getItem('token');
      const url = editingTreatment
        ? `${API_CONFIG.BASE_URL}/admin/treatments/${editingTreatment.id}`
        : `${API_CONFIG.BASE_URL}/admin/treatments`;

      const method = editingTreatment ? 'PUT' : 'POST';

      const response = await fetch(url, {
        method,
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (data.success) {
        setAlert({
          show: true,
          message: editingTreatment ? 'Препарат обновлен' : 'Препарат создан',
          severity: 'success'
        });
        handleCloseDialog();
        fetchTreatments();
        fetchDropdownData(); // Обновляем dropdown данные
      } else {
        setAlert({ show: true, message: data.message || 'Ошибка сохранения', severity: 'error' });
      }
    } catch (error) {
      setAlert({ show: true, message: 'Ошибка подключения к серверу', severity: 'error' });
    }
  };

  // Удаление препарата
  const handleDelete = async (id) => {
    if (!window.confirm('Вы уверены, что хотите удалить этот препарат?')) {
      return;
    }

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_CONFIG.BASE_URL}/admin/treatments/${id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      const data = await response.json();

      if (data.success) {
        setAlert({ show: true, message: 'Препарат удален', severity: 'success' });
        fetchTreatments();
      } else {
        setAlert({ show: true, message: data.message || 'Ошибка удаления', severity: 'error' });
      }
    } catch (error) {
      setAlert({ show: true, message: 'Ошибка подключения к серверу', severity: 'error' });
    }
  };

  // // Очистка фильтров
  // const handleClearFilters = () => {
  //   setSearch('');
  //   setDiseaseFilter('');
  //   setProductFilter('');
  //   setActiveFilter('');
  //   setPage(1);
  // };

  // const totalPages = Math.ceil(totalCount / limit);

  const columns = [
    {
      name: "plant_name",
      label: "Растение",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "disease_name",
      label: "Заболевание",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "product_name",
      label: "Препарат",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <Chip
            label={value}
            color="success"
            size="small"
            variant="outlined"
          />
        )
      }
    },
    {
      name: "status",
      label: "Статус",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <Chip
            icon={value === 'Неактивен' ? <BlockIcon /> : <CheckCircleIcon />}
            color={value === 'Неактивен' ? 'error' : 'success'}
            label={value}
            size="small"
            variant="outlined"
          />)
      }
    },
    {
      name: "dosage",
      label: "Дозировка",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({
          style: { maxWidth: "350px" }
        }),
        customBodyRender: (value) => (
          <Chip
            label={value}
            color="info"
            size="small"
            variant="outlined"
          />)
      }
    },
  ];

  const capitalizeFirstLetter = (text) => {
    if (!text) return text;
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  const data = treatments.map((item, index) => ({
    index,
    plant_name: capitalizeFirstLetter(item.plant_name) || undefined,
    disease_name: capitalizeFirstLetter(item.disease_name) || undefined,
    product_name: item.product_name || undefined,
    status: item.is_active ? 'Активен' : 'Неактивен',
    dosage: item.dosage,
  }));

  // console.log(treatments, data);

  const options = {
    storageKey: 'treatments-table',
    jumpToPage: true,
    rowsPerPageOptions: [10, 25, 50, 100],
    filterType: 'multiselect',
    downloadOptions: {
      filename: `Препараты.${new Date().toISOString().split('T')[0]}.csv`,
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayedRowsOnly: true,
      }
    },
    textLabels: {
      body: {
        noMatch: loading ? (<Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}><CircularProgress /></Box>) : ('Подходящих записей не найдено'),
        toolTip: "Сортировка",
        columnHeaderTooltip: (column) => `Сортировка для ${column.label}`
      },
      pagination: {
        next: "Следующая страница",
        previous: "Предыдущая страница",
        rowsPerPage: "Строк на странице:",
        displayRows: "из",
        jumpToPage: "Перейти на страницу:",
      },
      toolbar: {
        search: "Поиск",
        downloadCsv: "Скачать CSV",
        print: "Печать",
        viewColumns: "Просмотр столбцов",
        filterTable: "Фильтр таблицы",
      },
      filter: {
        all: "Все",
        title: "ФИЛЬТРЫ",
        reset: "СБРОС",
      },
      viewColumns: {
        title: "Показать столбцы",
        titleAria: "Показать/скрыть столбцы таблицы",
      },
      selectedRows: {
        text: "выбрано",
        delete: "Удалить",
        deleteAria: "Удалить выбранные строки",
      },
    },
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {
      if (!canEdit) return null;
      return (
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <div style={{ marginRight: '0.5rem' }}>
            <Tooltip title={"Редактировать"}>
              <IconButton
                onClick={() => {
                  const selectedIndices = selectedRows.data.map(row => row.dataIndex);
                  const selectedData = selectedIndices.map(index => data[index]);
                  console.log("Processing custom action for:", selectedData);
                  setSelectedRows([]);
                }}
              ><EditIcon />
              </IconButton>
            </Tooltip>
          </div>
          <div style={{ marginRight: '0.5rem' }}>
            <Tooltip title={"Удалить"}>
              <IconButton
                onClick={() => {
                  const selectedIndices = selectedRows.data.map(row => row.dataIndex);
                  const selectedData = selectedIndices.map(index => data[index]);
                  console.log("Processing custom action for:", selectedData);
                  setSelectedRows([]);
                }}
              ><DeleteIcon />
              </IconButton>
            </Tooltip>
          </div>
        </div>)
    }
  };

  // const options = {
  //   serverSide: true,
  //   onTableChange: (action, tableState) => {
  //     this.xhrRequest('my.api.com/tableData', result => {
  //       this.setState({ data: result });
  //     });
  //   }
  // };

  const appTheme = useTheme();
  const getMuiTheme = () => createTheme(appTheme, {
    components: {
      MUIDataTableToolbar: {
        styleOverrides: {
          filterPaper: {
            width: '25%',
            minWidth: '20vw',
          },
        },
      },
      MuiGrid: {
        styleOverrides: {
          root: {
            flexBasis: '100% !important',
            maxWidth: '100% !important',
            width: '100%',
            marginLeft: '0',
          },
          item: {
            paddingLeft: '0 !important',
            paddingTop: '1rem !important',
          }
        }
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            borderRadius: '1rem',
            minWidth: '20vw !important',
            padding: '0.5rem !important',
          }
        }
      },
      MUIDataTableViewCol: {
        styleOverrides: {
          root: {
            padding: '1.5rem !important',
          }
        }
      },
      MuiIconButton: {
        styleOverrides: {
          root: {
            padding: '0.5rem !important',
          }
        }
      },
    },
  });

  return (
    <>
      {/* Заголовок */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 3 }}>
        <Box>
          <Typography variant="h5" component="h1" gutterBottom sx={{ fontWeight: 'bold' }}>
            Управление препаратами
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Справочник препаратов для обработки растений: создание, редактирование и удаление
          </Typography>
        </Box>
        {canEdit && (
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => handleOpenDialog()}
          >
            Добавить препарат
          </Button>
        )}
      </Box>

      {/* Таблица препаратов */}
      <ThemeProvider theme={getMuiTheme()}>
        <MUIDataTable
          title={"Препараты"}
          data={data}
          columns={columns}
          options={options}
        />
      </ThemeProvider>

      {/* Модальное окно для создания/редактирования */}
      <Dialog open={dialogOpen} onClose={handleCloseDialog} maxWidth="md" fullWidth>
        <DialogTitle>
          {editingTreatment ? 'Редактировать препарат' : 'Добавить препарат'}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12} md={6}>
              <Autocomplete
                freeSolo
                options={diseases}
                value={formData.disease_name}
                onChange={(event, newValue) => handleFormChange('disease_name', newValue || '')}
                onInputChange={(event, newInputValue) => handleFormChange('disease_name', newInputValue)}
                renderInput={(params) => (
                  <TextField {...params} label="Название болезни *" fullWidth />
                )}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Autocomplete
                freeSolo
                options={products}
                value={formData.product_name}
                onChange={(event, newValue) => handleFormChange('product_name', newValue || '')}
                onInputChange={(event, newInputValue) => handleFormChange('product_name', newInputValue)}
                renderInput={(params) => (
                  <TextField {...params} label="Название препарата *" fullWidth />
                )}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="URL изображения препарата"
                value={formData.product_image}
                onChange={(e) => handleFormChange('product_image', e.target.value)}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                multiline
                rows={3}
                label="Описание болезни"
                value={formData.disease_description}
                onChange={(e) => handleFormChange('disease_description', e.target.value)}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Autocomplete
                freeSolo
                options={dosages}
                value={formData.dosage}
                onChange={(event, newValue) => handleFormChange('dosage', newValue || '')}
                onInputChange={(event, newInputValue) => handleFormChange('dosage', newInputValue)}
                renderInput={(params) => (
                  <TextField {...params} label="Дозировка" fullWidth />
                )}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Ссылка на покупку"
                value={formData.purchase_link}
                onChange={(e) => handleFormChange('purchase_link', e.target.value)}
              />
            </Grid>

            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={formData.is_active}
                    onChange={(e) => handleFormChange('is_active', e.target.checked)}
                  />
                }
                label="Активный препарат"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Отмена</Button>
          <Button
            onClick={handleSave}
            variant="contained"
            disabled={!formData.disease_name || !formData.product_name}
          >
            {editingTreatment ? 'Обновить' : 'Создать'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Уведомления */}
      {alert.show && (
        <Alert
          severity={alert.severity}
          onClose={() => setAlert({ ...alert, show: false })}
          sx={{ mb: 2 }}
        >
          {alert.message}
        </Alert>
      )}
    </>
  );
};

export default AdminTreatmentsPage; 